var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicTipPersonalization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 302.92 42.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(199.95 2.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 102,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(199.95 2.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.1,
    width: 101.97,
    height: 39.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(199.95 2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,28a2,2,0,0,1-2-2V4.1a2,2,0,0,1,2-2H96a2,2,0,0,1,2,2V26a2,2,0,0,1-2,2H56.17l-3.58,4.83a2,2,0,0,1-2.79.42,2.09,2.09,0,0,1-.42-.42L45.8,28Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 199.95,
    y: 2.9,
    width: 102,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAoCAYAAAAMjY9+AAAACXBIWXMAAAsSAAALEgHS3X78AAACUUlEQVRoQ+2bwXKrMAxFjwtt//9zmyboLfAFoZCZLEgq3ujMeAwOC9tHxrSIZmZ4WmuN4u1YENHMzMvwdWwrjsVc7Y8xMxuDlAZ8uOIFFcciIZMramfsJxIw9LaRkvNKzJUbcO1FgkxiYJYwAl/AZz8eentxPJJwBS697QpYa635FSMxn8A3s6AS8zom5tXy687VRhQzMIv56kW3tOJ4JKH1WougwTzxzRXJGV2pPeZ4jDXgB7ZSFjGicS9JdXEsjVWOL8vve5Nef8O8jzi/y3mthqSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKSUmKTsifF5TsVreTjP/g2mhaLkgKyr6tmXeFmDbGKdZz/v0NOXooybK623PTsJ7yK+Bt8jBlom1Kcr61x7QcuKiclnynO6kWvFeBk+gSH20UfjRBh0Enz60i+rHGArJiaf+ZSaLEjCB2sWz9B/Uz99ftZeRGZB/ZQYZWJuVowuvDGLmdhJqUmAxCgxcWLNGhU+Ei/sDDoBe1vHrhhd5I+zpS75tKqReTCaaB84kvLTy4XtoLPIgfvb7QSYmdloZtYz/nWR9ppMK0VIzOZ+3FGQadU/EpMJc/UmaEaYFTk5vvPZxMAsRv1U/xRM9NpLudtYE3EXKPqAaYwN8bqdtj+jB8/eLWxiHcuV7f6ybPwPxpgSv2mmJ6xsrRAd6+lMG6meyE4nBU4mxvHoYUXnEpJxX3mKdrJAAojfjMb/AFgoj27TqTmlGCB+XR0fUpZBnVEKnFjM/84/rIMbfv5xTI8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-197.95,28a2,2,0,0,1-2-2V4.1a2,2,0,0,1,2-2h90a2,2,0,0,1,2,2V26a2,2,0,0,1-2,2h-39.81l-3.58,4.83a2,2,0,0,1-2.79.42,2.09,2.09,0,0,1-.42-.42L-158.15,28Z",
    transform: "translate(199.95 2.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 198.95,
    width: 103.97,
    height: 41.54
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(214.84 20.77)"
  }, "Personalization")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTipPersonalization);
export default __webpack_public_path__ + "static/media/TopicTip_Personalization.fe915eea582427f1331a414e3ad753fb.svg";
export { ForwardRef as ReactComponent };